import type { HTMLAttributes, ReactNode } from 'react';
import './Container.css';

export interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

/**
 * Shared page-width wrapper used by layouts across both apps.
 */
export function Container({ className, children, ...rest }: ContainerProps) {
  const classes = ['dma-container', className].filter(Boolean).join(' ');
  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
}
